<template>
    <div>
        <v-card flat>
            <v-card-title class="justify-center">Customer Balance Summary</v-card-title>
            <v-card-text class="justify-center"></v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    name: "CustomerBalance",
    components: {

    },
    props: {},
    data() {
        return {}
    },
    computed: {

    },
    methods: {}
}
</script>